import { property } from '@wonderlandengine/api/decorators.js';
import { Component, NumberArray } from '@wonderlandengine/api';

/**
 * Colour Description:
 */
export class ColourDescription extends Component {
	static TypeName = 'colour-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	colourId: string = '';

	@property.color()
	colour!: NumberArray;
}
